import { PureComponent, Fragment } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Switch, Route } from 'react-router'
import { Provider } from 'react-redux'
import { getDefaultStore } from 'shared/redux/init-store'
import entryPoint from 'shared/components/entry-point-hoc'
import Header from 'modules/header/components/header'
import routes from 'shared/routes'
import ChannelStoriesRoute from './stories/route'
import StoryRoute from './story/components/route'
import TrendingRoute from './trending/route'
import GDBootstrapper from 'shared/components/gd-bootstrapper'
import HomepageBeta from './homepage-beta/route'
import Homebase from './homebase/route'
import GifDetailRoute from './gif-detail/components/route'
import Join from './user/join'
import Login from './user/login'
import ArtistsRoute from './artists/route'
import AppsLandingRoute from './apps-landing/components/route'
import CurationRoute from './curation-station/route'
import VideoDetail from './video-detail'
import FilmFest from './film-fest/route'

const store = getDefaultStore({})

@entryPoint(store)
class App extends PureComponent {
    render() {
        const { pageData, user, showSearch, showBrowse, searchTerm } = this.props
        return (
            <Provider store={store}>
                <BrowserRouter>
                    <GDBootstrapper initData={pageData}>
                        <Fragment>
                            <Header {...{ user, showSearch, showBrowse, searchTerm }} />
                            <Switch>
                                <Route {...routes.JOIN} component={Join} />
                                <Route {...routes.LOGIN} component={Login} />
                                <Route {...routes.CHANNEL_STORIES} component={ChannelStoriesRoute} />
                                <Route {...routes.ARTISTS} component={ArtistsRoute} />
                                <Route {...routes.STORY} component={StoryRoute} />
                                <Route {...routes.GIF_DETAIL} component={GifDetailRoute} />
                                <Route {...routes.VIDEO_DETAIL} component={VideoDetail} />
                                <Route {...routes.FILM_FEST} component={FilmFest} />
                                <Route {...routes.TRENDING} component={TrendingRoute} />
                                <Route {...routes.APPS} component={AppsLandingRoute} />
                                <Route {...routes.HOME} component={HomepageBeta} />
                                <Route {...routes.HOMEBASE} component={Homebase} />
                                <Route {...routes.EDIT_GIFS} component={CurationRoute} />
                            </Switch>
                        </Fragment>
                    </GDBootstrapper>
                </BrowserRouter>
            </Provider>
        )
    }
}

export default App
